import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ButtonPurpose } from '@mhe/ngx-shared';

@Component({
  selector: 'rdrx-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalHeaderComponent {
  @Input() withClose = true;
  @Output() closeEvent = new EventEmitter();

  ButtonPurpose = ButtonPurpose;

  closeClick(): void {
    this.closeEvent.emit();
  }
}
